// src/app/guards/redirect-if-authenticated.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { switchMap, of, tap } from 'rxjs';
import { AuthService } from './core/auth/auth.service';
import { OrgService } from './modules/org-sys-area/services/org.service';

export const redirectIfAuthenticatedGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const orgService = inject(OrgService);

    return authService.check().pipe(
        switchMap(authenticated => {
            if (!authenticated) {
                // Not logged in → skip redirection
                router.navigate(['/sign-in']);
                return of(false);
            }

            const orgId = localStorage.getItem('organisation');

            if (orgId) {
                router.navigate([`/${orgId}/bp`]);
                return of(false);
            }

            return orgService.getSimpleOrganisationsForUsers().pipe(
                tap(() => {
                    const orgId = localStorage.getItem('organisation');

                    router.navigate([`/${orgId}/bp`]);
                }),
                switchMap(() => of(false))
            );
        })
    );
};
